import { CatalogoGenerico } from '@/shared/model/seguimiento/catalogo-generico.model';

export default class CatalogosArs {
  public static obtenerModalidades(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('PRESENCIAL', 'PRESENCIAL', 'Presencial'),
      new CatalogoGenerico('VIRTUAL', 'VIRTUAL', 'Virtual'),
      new CatalogoGenerico('HIBRIDA', 'HIBRIDA', 'Híbrida'),
    ];
  }

  public static obtenerCategoriasRetribucion(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('INCIDENCIA', 'INCIDENCIA', 'Incidencia'),
      new CatalogoGenerico('DIFUSION', 'DIFUSION', 'Difusión'),
      new CatalogoGenerico('PROMOCION', 'PROMOCION', 'Promoción'),
    ];
  }

  public static obtenerSubcategorias(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico(
        'EVENTOS_FORMACION_VOCACIONES',
        'EVENTOS_FORMACION_VOCACIONES',
        'Organizar/participar en eventos de formación y promoción de vocaciones científicas'
      ),
      new CatalogoGenerico('MATERIALES_MULTIMEDIA', 'MATERIALES_MULTIMEDIA', 'Crear materiales multimedia y de comunicación social'),
      new CatalogoGenerico(
        'INICIATIVAS_SOCIALES_INNOVACION',
        'INICIATIVAS_SOCIALES_INNOVACION',
        'Presentar iniciativas sociales y de innovación'
      ),
      new CatalogoGenerico('ANIMACION_SOCIOCULTURAL', 'ANIMACION_SOCIOCULTURAL', 'Realizar actividades de animación sociocultural'),
      new CatalogoGenerico(
        'EDUCACION_SUSTENTABILIDAD',
        'EDUCACION_SUSTENTABILIDAD',
        'Participar en procesos de educación para la sustentabilidad'
      ),
      new CatalogoGenerico('RESULTADOS_INVESTIGACION', 'RESULTADOS_INVESTIGACION', 'Presentar resultados de su investigación'),
      new CatalogoGenerico('CURSOS_TALLERES', 'CURSOS_TALLERES', 'Impartir cursos o talleres'),
      new CatalogoGenerico('NOTAS_ARTICULOS', 'NOTAS_ARTICULOS', 'Elaborar notas y artículos de difusión'),
      new CatalogoGenerico('TRADUCCION_LENGUAS_INDIGENAS', 'TRADUCCION_LENGUAS_INDIGENAS', 'Traducir investigaciones en lenguas indígenas'),
      new CatalogoGenerico('REDES_COLABORACION', 'REDES_COLABORACION', 'Creación de redes sociales de colaboración'),
      new CatalogoGenerico('EVENTOS_CULTURALES', 'EVENTOS_CULTURALES', 'Participar/organizar eventos culturales sin fines de lucro'),
      new CatalogoGenerico(
        'SERVICIO_SOCIAL',
        'SERVICIO_SOCIAL',
        'Realizar servicio social en instituciones y organizaciones de la sociedad civil'
      ),
      new CatalogoGenerico('COMUNIDADES_APRENDIZAJE', 'COMUNIDADES_APRENDIZAJE', 'Construir comunidades de aprendizaje'),
      new CatalogoGenerico(
        'INNOVACION_SOCIAL_TECNOLOGICA',
        'INNOVACION_SOCIAL_TECNOLOGICA',
        'Colaborar en procesos de innovación social y tecnológica'
      ),
      new CatalogoGenerico('CAMPAÑAS_SALUD', 'CAMPAÑAS_SALUD', 'Crear campañas de salud y cuidado para sectores vulnerables'),
      new CatalogoGenerico('RESTAURACION_ECOLOGICA', 'RESTAURACION_ECOLOGICA', 'Desarrollar actividades para la restauración ecológica'),
      new CatalogoGenerico(
        'BRIGADAS_EMERGENCIAS',
        'BRIGADAS_EMERGENCIAS',
        'Participar en brigadas para la atención de emergencias nacionales'
      ),
      new CatalogoGenerico(
        'COMITES_ETICA',
        'COMITES_ETICA',
        'Participar en Comités de Ética, prevención del acoso sexual y atención a las diversidades'
      ),
      new CatalogoGenerico('POLITICAS_PUBLICAS', 'POLITICAS_PUBLICAS', 'Creación de recomendaciones de políticas públicas'),
      new CatalogoGenerico('DERECHOS_HUMANOS', 'DERECHOS_HUMANOS', 'Brindar asesorías gratuitas en materia de Derechos Humanos'),
      new CatalogoGenerico(
        'ASESORIA_ESPECIALIZADA',
        'ASESORIA_ESPECIALIZADA',
        'Brindar asesoría gratuita jurídica, financiera, fiscal, psicológica o para jóvenes emprendedores'
      ),
      new CatalogoGenerico(
        'CAPACITACION_INSTITUCIONES',
        'CAPACITACION_INSTITUCIONES',
        'Capacitar en instituciones y empresas sobre habilidades y manejo de equipo o materiales especializados'
      ),
      new CatalogoGenerico('COOPERATIVAS', 'COOPERATIVAS', 'Asesorar a comunidades de escasos recursos para la creación de cooperativas'),
      new CatalogoGenerico('CONSULTAS_MEDICAS', 'CONSULTAS_MEDICAS', 'Impartir consultas médicas y realizar cirugías gratuitas'),
      new CatalogoGenerico('EVENTOS_SECIHTI', 'EVENTOS_SECIHTI', 'Colaborar con la Secretaría en eventos'),
      new CatalogoGenerico(
        'EVALUADOR_REVISOR',
        'EVALUADOR_REVISOR',
        'Participar como evaluador o revisor de procesos dentro de la Secretaría'
      ),
      new CatalogoGenerico('ADJUNTOS_DOCENTES', 'ADJUNTOS_DOCENTES', 'Colaborar como adjuntos de los docentes'),
      new CatalogoGenerico('ASESORIA_JOVENES', 'ASESORIA_JOVENES', 'Asesorar a jóvenes en su formación académica'),
      new CatalogoGenerico(
        'REVISION_TRABAJOS_POSGRADO',
        'REVISION_TRABAJOS_POSGRADO',
        'Apoyar a programas de posgrado para revisar tesis, tesinas y trabajos terminales'
      ),
    ];
  }

  public static obtenerTiposPoblacion(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('NNA', 'NNA', 'Niñas, niños y adolescentes'),
      new CatalogoGenerico('JOVENES', 'JOVENES', 'Jóvenes'),
      new CatalogoGenerico('MUJERES', 'MUJERES', 'Mujeres'),
      new CatalogoGenerico('ADULTOS_MAYORES', 'ADULTOS_MAYORES', 'Personas adultas mayores'),
      new CatalogoGenerico('INDIGENAS', 'INDIGENAS', 'Personas indígenas'),
      new CatalogoGenerico('AFROMEXICANAS', 'AFROMEXICANAS', 'Personas afromexicanas'),
      new CatalogoGenerico('DISCAPACIDAD', 'DISCAPACIDAD', 'Personas con discapacidad'),
      new CatalogoGenerico('COMUNIDAD_EDUCATIVA', 'COMUNIDAD_EDUCATIVA', 'Comunidad educativa'),
      new CatalogoGenerico('PRODUCTORES_RURALES', 'PRODUCTORES_RURALES', 'Productores rurales'),
      new CatalogoGenerico('SERVIDORES_PUBLICOS', 'SERVIDORES_PUBLICOS', 'Servidores públicos'),
      new CatalogoGenerico('OSC', 'OSC', 'Organizaciones de la sociedad civil'),
      new CatalogoGenerico('COMUNIDAD_GENERAL', 'COMUNIDAD_GENERAL', 'Comunidad en general'),
    ];
  }

  public static obtenerProductosGenerados(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('TALLERES', 'TALLERES', 'Talleres impartidos'),
      new CatalogoGenerico('CONFERENCIAS', 'CONFERENCIAS', 'Conferencias'),
      new CatalogoGenerico('MATERIAL_DIDACTICO', 'MATERIAL_DIDACTICO', 'Material didáctico'),
      new CatalogoGenerico('CARTELES', 'CARTELES', 'Carteles'),
      new CatalogoGenerico('INFOGRAFIAS', 'INFOGRAFIAS', 'Infografías'),
      new CatalogoGenerico('CURSOS', 'CURSOS', 'Cursos'),
      new CatalogoGenerico('DIAGNOSTICOS', 'DIAGNOSTICOS', 'Diagnósticos'),
      new CatalogoGenerico('PROTOCOLOS', 'PROTOCOLOS', 'Protocolos'),
      new CatalogoGenerico('MANUALES', 'MANUALES', 'Manuales'),
      new CatalogoGenerico('ARTICULOS', 'ARTICULOS', 'Artículos'),
      new CatalogoGenerico('MATERIAL_AUDIOVISUAL', 'MATERIAL_AUDIOVISUAL', 'Material audiovisual'),
    ];
  }

  public static obtenerEvidencias(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('FOTOGRAFIAS', 'FOTOGRAFIAS', 'Fotografías'),
      new CatalogoGenerico('LISTAS_ASISTENCIA', 'LISTAS_ASISTENCIA', 'Listas de asistencia'),
      new CatalogoGenerico('CONSTANCIAS', 'CONSTANCIAS', 'Constancias'),
      new CatalogoGenerico('MATERIAL_APOYO', 'MATERIAL_APOYO', 'Material de apoyo'),
      new CatalogoGenerico('PUBLICACIONES', 'PUBLICACIONES', 'Publicaciones'),
      new CatalogoGenerico('VIDEOS', 'VIDEOS', 'Videos'),
      new CatalogoGenerico('ENCUESTAS', 'ENCUESTAS', 'Encuestas'),
      new CatalogoGenerico('TESTIMONIOS', 'TESTIMONIOS', 'Testimonios'),
    ];
  }

  public static obtenerContribuciones(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('DIFUSION_CONOCIMIENTO', 'DIFUSION_CONOCIMIENTO', 'Difusión del conocimiento'),
      new CatalogoGenerico('FORTALECIMIENTO_CAPACIDADES', 'FORTALECIMIENTO_CAPACIDADES', 'Fortalecimiento de capacidades'),
      new CatalogoGenerico('PROBLEMATICAS_LOCALES', 'PROBLEMATICAS_LOCALES', 'Atención de problemáticas locales'),
      new CatalogoGenerico('VINCULACION_UNIVERSIDAD_SOCIEDAD', 'VINCULACION_UNIVERSIDAD_SOCIEDAD', 'Vinculación universidad-sociedad'),
      new CatalogoGenerico('INCLUSION_SOCIAL', 'INCLUSION_SOCIAL', 'Inclusión social'),
      new CatalogoGenerico('EQUIDAD_GENERO', 'EQUIDAD_GENERO', 'Equidad de género'),
      new CatalogoGenerico('DESARROLLO_COMUNITARIO', 'DESARROLLO_COMUNITARIO', 'Desarrollo comunitario'),
      new CatalogoGenerico('SUSTENTABILIDAD_AMBIENTAL', 'SUSTENTABILIDAD_AMBIENTAL', 'Sustentabilidad ambiental'),
      new CatalogoGenerico('INNOVACION_SOCIAL', 'INNOVACION_SOCIAL', 'Innovación social'),
    ];
  }

  public static obtenerAreasConocimiento(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('FISICO_MATEMATICAS', 'FISICO_MATEMATICAS', 'Físico-Matemáticas'),
      new CatalogoGenerico('BIOLOGIA_QUIMICA', 'BIOLOGIA_QUIMICA', 'Biología y Química'),
      new CatalogoGenerico('MEDICINA_SALUD', 'MEDICINA_SALUD', 'Medicina y Ciencias de la Salud'),
      new CatalogoGenerico('CIENCIAS_CONDUCTA', 'CIENCIAS_CONDUCTA', 'Ciencias de la Conducta'),
      new CatalogoGenerico('HUMANIDADES', 'HUMANIDADES', 'Humanidades'),
      new CatalogoGenerico('CIENCIAS_SOCIALES', 'CIENCIAS_SOCIALES', 'Ciencias Sociales'),
      new CatalogoGenerico('CIENCIAS_AGRICULTURA', 'CIENCIAS_AGRICULTURA', 'Ciencias de la Agricultura'),
      new CatalogoGenerico('INGENIERIAS', 'INGENIERIAS', 'Ingenierías'),
      new CatalogoGenerico('INTERDISCIPLINARIA', 'INTERDISCIPLINARIA', 'Interdisciplinaria'),
    ];
  }

  public static obtenerTemasPrioritarios(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('EDUCACION', 'EDUCACION', 'Educación'),
      new CatalogoGenerico('SALUD', 'SALUD', 'Salud'),
      new CatalogoGenerico('MEDIO_AMBIENTE', 'MEDIO_AMBIENTE', 'Medio ambiente'),
      new CatalogoGenerico('IGUALDAD_GENERO', 'IGUALDAD_GENERO', 'Igualdad de género'),
      new CatalogoGenerico('DERECHOS_HUMANOS', 'DERECHOS_HUMANOS', 'Derechos humanos'),
      new CatalogoGenerico('CULTURA', 'CULTURA', 'Cultura'),
      new CatalogoGenerico('DESARROLLO_COMUNITARIO', 'DESARROLLO_COMUNITARIO', 'Desarrollo comunitario'),
      new CatalogoGenerico('SOBERANIA_ALIMENTARIA', 'SOBERANIA_ALIMENTARIA', 'Soberanía alimentaria'),
      new CatalogoGenerico('INNOVACION_TECNOLOGICA', 'INNOVACION_TECNOLOGICA', 'Innovación tecnológica'),
    ];
  }

  public static obtenerOpcionesReplicable(): Array<CatalogoGenerico> {
    return [
      new CatalogoGenerico('SI', 'SI', 'Sí'),
      new CatalogoGenerico('NO', 'NO', 'No'),
      new CatalogoGenerico('PARCIALMENTE', 'PARCIALMENTE', 'Parcialmente'),
    ];
  }

  public static obtenerRegion(claveRegion: string): CatalogoGenerico {
    const regiones: Record<string, CatalogoGenerico> = {
      AGS: new CatalogoGenerico('1', 'OCCIDENTE', 'Occidente'),
      BC: new CatalogoGenerico('2', 'NOROESTE', 'Noroeste'),
      BCS: new CatalogoGenerico('2', 'NOROESTE', 'Noroeste'),
      CAMP: new CatalogoGenerico('3', 'SURESTE', 'Sureste'),
      COAH: new CatalogoGenerico('4', 'NOROESTE', 'Noreste'),
      COLI: new CatalogoGenerico('1', 'OCCIDENTE', 'Occidente'),
      CHPS: new CatalogoGenerico('3', 'SURESTE', 'Sureste'),
      CHIH: new CatalogoGenerico('4', 'NOROESTE', 'Noreste'),
      CDMX: new CatalogoGenerico('5', 'CENTRO', 'Centro'),
      DGO: new CatalogoGenerico('4', 'NOROESTE', 'Noreste'),
      GTO: new CatalogoGenerico('5', 'CENTRO', 'Centro'),
      GRO: new CatalogoGenerico('5', 'CENTRO', 'Centro'),
      HGO: new CatalogoGenerico('6', 'SUR_ORIENTE', 'Sur oriente'),
      JAL: new CatalogoGenerico('1', 'OCCIDENTE', 'Occidente'),
      EMEX: new CatalogoGenerico('5', 'CENTRO', 'Centro'),
      MICH: new CatalogoGenerico('1', 'OCCIDENTE', 'Occidente'),
      MOR: new CatalogoGenerico('5', 'CENTRO', 'Centro'),
      NAY: new CatalogoGenerico('1', 'OCCIDENTE', 'Occidente'),
      NL: new CatalogoGenerico('4', 'NOROESTE', 'Noreste'),
      OAX: new CatalogoGenerico('6', 'SUR_ORIENTE', 'Sur oriente'),
      PUE: new CatalogoGenerico('6', 'SUR_ORIENTE', 'Sur oriente'),
      QRO: new CatalogoGenerico('5', 'CENTRO', 'Centro'),
      QROO: new CatalogoGenerico('3', 'SURESTE', 'Sureste'),
      SLP: new CatalogoGenerico('5', 'CENTRO', 'Centro'),
      SIN: new CatalogoGenerico('2', 'NOROESTE', 'Noroeste'),
      SON: new CatalogoGenerico('2', 'NOROESTE', 'Noroeste'),
      TAB: new CatalogoGenerico('3', 'SURESTE', 'Sureste'),
      TAMP: new CatalogoGenerico('4', 'NOROESTE', 'Noreste'),
      TLAX: new CatalogoGenerico('6', 'SUR_ORIENTE', 'Sur oriente'),
      VER: new CatalogoGenerico('6', 'SUR_ORIENTE', 'Sur oriente'),
      YUC: new CatalogoGenerico('3', 'SURESTE', 'Sureste'),
      ZAC: new CatalogoGenerico('4', 'NOROESTE', 'Noreste'),
    };
    return regiones[claveRegion];
  }
}
